"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-practice-icon-text.svg.js",
    _path,
    _path2,
    _path3,
    _path4,
    _path5,
    _path6,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 115,
    height: 32,
    viewBox: "0 0 115 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M25.6 0H6.4A6.4 6.4 0 000 6.4v19.2A6.4 6.4 0 006.4 32h19.2a6.4 6.4 0 006.4-6.4V6.4A6.4 6.4 0 0025.6 0z",
    fill: "url(#prefix__paint0_linear_5538_35775)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.815 12.148l-1.171 12.774H5.57L4.4 12.148h23.415zm-10.537 2.904h-2.341v2.322h-2.342v2.323h2.341v2.322h2.342v-2.323h2.341v-2.322h-2.341v-2.322z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 11.567h23.415l-2.342-1.16H6.741L4.4 11.566zM12.595 7.793l.828 1.162v.872l-.828-.002V7.793zm7.024 0v2.032h-.817v-.873l.817-1.159z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  })), _path4 || (_path4 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.595 7.2h7.024l-.828 1.161h-5.373L12.595 7.2z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  })), _path5 || (_path5 = React.createElement("path", {
    d: "M40 10.966V6.02h1.152v.707c.204-.48.698-.805 1.317-.805.668 0 1.123.285 1.365.864.281-.58.814-.864 1.598-.864 1.075 0 1.695.756 1.695 1.982v3.062h-1.163V8.07c0-.676-.32-1.098-.872-1.098-.571 0-.968.47-.968 1.147v2.846h-1.151V8.071c0-.676-.32-1.098-.872-1.098-.542 0-.949.48-.949 1.147v2.846H40zm9.432.068l-2.004-5.015h1.19l1.423 3.611 1.463-3.61h1.19l-2.866 6.85h-1.18l.784-1.836zm20.045-6.267c-.51-.472-1.231-.721-2.092-.721h-1.63v6.957h1.153v-1.6h.477c.86 0 1.583-.247 2.09-.715.514-.474.786-1.15.786-1.954 0-.81-.272-1.49-.784-1.967zm-2.569.382h.44c1.155 0 1.74.534 1.74 1.585 0 1.039-.585 1.565-1.74 1.565h-.44V5.15zM55.941 6.973l-.51-.244c-.762-.363-.953-.513-.953-.949 0-.411.306-.688.762-.688.472 0 .776.17 1.016.57l.146.243.928-.601-.143-.233C56.748 4.35 56.108 4 55.231 4c-1.099 0-1.896.756-1.896 1.799 0 1.017.617 1.515 1.612 1.988l.511.244c.796.374 1.026.627 1.026 1.127 0 .513-.41.82-1.096.82-.617 0-1.117-.305-1.405-.856l-.129-.246-.995.53.129.248c.483.924 1.34 1.433 2.41 1.433.664 0 1.223-.178 1.618-.516.406-.348.62-.842.62-1.432 0-1.12-.648-1.66-1.695-2.166zm8.09 1.839l-.16.217c-.46.62-1.123.949-1.919.949-1.343 0-2.318-1.024-2.318-2.434 0-1.387.977-2.433 2.27-2.433.757 0 1.363.292 1.802.868l.164.214.907-.662-.17-.228C63.964 4.45 63.034 4 61.914 4c-1.973 0-3.46 1.523-3.46 3.543-.005.977.345 1.874.987 2.528.642.653 1.53 1.018 2.491 1.018 1.2 0 2.158-.467 2.849-1.388l.173-.23-.924-.66z",
    fill: "#CFCFCF",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    },
    __self: this
  })), _path6 || (_path6 = React.createElement("path", {
    d: "M42.822 16.978c1.402 0 2.479.249 3.23.746.75.489 1.126 1.294 1.126 2.416 0 1.13-.38 1.949-1.14 2.456-.76.497-1.845.746-3.256.746h-.665v3.148H40v-9.268c.461-.09.95-.153 1.465-.19.516-.036.968-.054 1.357-.054zm.136 1.805c-.154 0-.308.004-.461.013-.145.01-.272.018-.38.027v2.714h.665c.732 0 1.284-.1 1.655-.298.37-.2.556-.57.556-1.113 0-.262-.05-.48-.15-.651a.98.98 0 00-.406-.407 1.607 1.607 0 00-.638-.217 4.795 4.795 0 00-.841-.068zM52.843 16.978c1.411 0 2.492.253 3.243.76.75.497 1.126 1.275 1.126 2.334 0 .66-.153 1.198-.461 1.614-.298.407-.733.729-1.303.964.19.235.39.506.597.814.209.298.412.615.611.95.208.325.407.669.597 1.03.19.354.366.702.53 1.046h-2.375c-.172-.308-.349-.62-.53-.937a15.421 15.421 0 00-.542-.922c-.181-.299-.362-.58-.543-.841a8.549 8.549 0 00-.543-.733h-1.044v3.433h-2.117v-9.268c.461-.09.936-.153 1.425-.19.497-.036.94-.054 1.33-.054zm.122 1.805c-.153 0-.294.004-.42.013l-.34.027v2.551h.598c.796 0 1.366-.1 1.71-.298.343-.2.515-.538.515-1.018 0-.461-.177-.787-.53-.977-.343-.199-.854-.298-1.533-.298zM67.216 26.49c-.1-.326-.213-.66-.34-1.005l-.352-1.03H62.86c-.117.343-.24.687-.366 1.03a32.01 32.01 0 00-.326 1.005H59.97c.353-1.013.688-1.95 1.004-2.81.317-.858.624-1.668.923-2.428.307-.76.606-1.479.895-2.157.299-.688.606-1.357.923-2.008h2.022c.307.65.61 1.32.909 2.008.298.678.597 1.397.895 2.157.308.76.62 1.57.936 2.429.317.86.652 1.796 1.004 2.809h-2.265zm-2.538-7.273c-.045.136-.113.321-.203.556l-.312.814c-.118.308-.25.647-.394 1.018-.136.37-.276.76-.42 1.167h2.673a136.67 136.67 0 00-.421-1.167c-.136-.37-.267-.71-.394-1.018l-.312-.814a47.65 47.65 0 00-.217-.556zM75.999 26.68c-1.53 0-2.696-.426-3.501-1.276-.796-.85-1.194-2.058-1.194-3.623 0-.778.122-1.47.366-2.076a4.404 4.404 0 011.004-1.546 4.153 4.153 0 011.52-.964 5.482 5.482 0 011.913-.325c.398 0 .76.031 1.086.095.325.054.61.122.855.203.244.072.447.15.61.23.163.082.28.146.353.19l-.61 1.71a5.082 5.082 0 00-1.018-.393 4.751 4.751 0 00-1.303-.163c-.326 0-.647.054-.963.163a2.195 2.195 0 00-.828.529 2.583 2.583 0 00-.57.923c-.145.38-.217.84-.217 1.384 0 .434.045.84.136 1.22.1.372.253.693.461.964.217.271.498.489.841.651.344.154.76.231 1.249.231.307 0 .583-.018.827-.054.244-.036.462-.077.651-.122.19-.055.358-.113.503-.177.144-.063.275-.122.393-.176l.584 1.696c-.299.18-.72.344-1.262.488-.543.145-1.172.218-1.886.218zM89.132 17.087v1.804h-2.836v7.599h-2.117V18.89h-2.835v-1.804h7.788zM91.849 17.087h2.117v9.403h-2.117v-9.403zM101.787 26.68c-1.529 0-2.696-.426-3.501-1.276-.796-.85-1.194-2.058-1.194-3.623 0-.778.122-1.47.366-2.076a4.403 4.403 0 011.004-1.546 4.153 4.153 0 011.52-.964 5.483 5.483 0 011.913-.325c.398 0 .76.031 1.086.095.325.054.61.122.854.203.245.072.448.15.611.23.163.082.28.146.353.19l-.611 1.71a5.067 5.067 0 00-1.017-.393 4.752 4.752 0 00-1.303-.163c-.326 0-.647.054-.963.163a2.192 2.192 0 00-.828.529 2.584 2.584 0 00-.57.923c-.145.38-.217.84-.217 1.384 0 .434.045.84.136 1.22.1.372.253.693.461.964.217.271.498.489.841.651.344.154.76.231 1.249.231.307 0 .583-.018.827-.054a7.63 7.63 0 00.652-.122c.19-.055.357-.113.502-.177.144-.063.275-.122.393-.176l.584 1.696c-.299.18-.72.344-1.262.488-.543.145-1.172.218-1.886.218zM107.654 26.49v-9.403h6.35v1.777h-4.233v1.845h3.758v1.737h-3.758v2.266h4.545v1.778h-6.662z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  })), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear_5538_35775",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#F7F7F7",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;